export enum ApplicationStatus {
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
}
